import React, { useState } from "react";

/**
 * CompanyLogo: renders a Clearbit logo for a company name.
 * Falls back to a colored circle with the company's initials on error.
 */
export default function CompanyLogo({ company, size = 44, className = "" }) {
  const [error, setError] = useState(false);
  const initials = (company || "?")
    .split(/\s+/).filter(Boolean).slice(0, 2)
    .map((w) => w[0]?.toUpperCase()).join("") || "?";

  // Heuristic domain from company name
  const slug = (company || "")
    .toLowerCase()
    .replace(/[^\w\s.-]/g, "")
    .replace(/\s+(gmbh|ag|inc|llc|ltd|corp|co|company|labs|studio|group|holdings|technologies)\.?$/g, "")
    .trim()
    .replace(/\s+/g, "");
  const url = slug ? `https://logo.clearbit.com/${slug}.com` : null;

  const style = {
    width: size, height: size, minWidth: size, minHeight: size,
    borderRadius: 10, border: "2px solid #0A0A0A",
    boxShadow: "2px 2px 0 0 #0A0A0A",
    background: "#fff",
    overflow: "hidden",
  };

  // Deterministic bg color for initials fallback
  const palette = ["#4338ca", "#ec4899", "#22c55e", "#f97316", "#eab308", "#0ea5e9"];
  const idx = Math.abs((company || "").split("").reduce((a, c) => a + c.charCodeAt(0), 0)) % palette.length;
  const bg = palette[idx];

  if (!url || error) {
    return (
      <div className={className} style={{ ...style, background: bg }}>
        <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 900, fontSize: size * 0.4 }}>{initials}</div>
      </div>
    );
  }
  return (
    <div className={className} style={style}>
      <img
        src={url}
        alt={`${company} logo`}
        width={size}
        height={size}
        onError={() => setError(true)}
        style={{ width: "100%", height: "100%", objectFit: "contain", background: "#fff" }}
        referrerPolicy="no-referrer"
      />
    </div>
  );
}
